module.exports = __webpack_public_path__ + "static/media/add_photo_alternate_rounded.5d66673e.svg";